import { PropsWithChildren } from 'react';

function Main(props: PropsWithChildren) {
  const { children } = props;

  return <main className='main'>{children}</main>;
}

export default Main;
